module.exports = __webpack_public_path__ + "media/packs/images/update-icons/gate-ae0ed02ba23549535cc573b4d4bdb167.svg";